import { Button, ButtonProps } from '@bpinternal/ui-kit-next'
import { Loader2 } from 'lucide-react'
import { cn } from '~/utils'

export function AsyncButton({ children, loading, ...props }: ButtonProps & { loading?: boolean }) {
  return (
    <Button disabled={loading} {...props}>
      {loading && <Loader2 className="absolute h-4 w-4 animate-spin" />}
      <div className={cn('flex items-center gap-2', { invisible: loading })}>{children}</div>
    </Button>
  )
}
